import template from '../templates/revisionButtonTemplate.html';

export default Marionette.View.extend({
    template: Handlebars.compile(template)
});
